<template>
    <div class="mb-5">
        <!-- <b-alert
            :show="error" 
            dismissible
            variant="danger"
        >
            {{ errorMsg }}
        </b-alert> -->
        
        <div class="d-flex justify-content-between align-items-center mb-4">
            <h3>{{ itemTitle }}</h3>
            <b-button variant="success" @click="startCreate">
                <b-icon icon="plus-circle" class="mr-2"></b-icon>
                New {{ itemNameSingularCapitalized }}
            </b-button>
        </div>

        <div
            class="d-flex justify-content-between align-items-center mb-2"
        >
            <b-input-group
                v-if="totalRows" 
                class="spl-inputs-search w-auto bg-white flex-grow-1 mr-3 min-width-250"
                :class="{'filled': value}"
            >
                <b-input-group-prepend is-text>
                    <b-icon icon="search"></b-icon>
                </b-input-group-prepend>
                <b-form-input
                    v-model="filterString"
                    type="search"
                    placeholder="Search..."
                ></b-form-input>
            </b-input-group>

            <base-table-pagination
                v-if="totalRows" 
                :current-page.sync="currentPage"
                :per-page.sync="perPage"
                :total-items="totalRows"
                :item-name="itemNamePlural"
            ></base-table-pagination>
        </div>

        <b-table
            small
            :items="itemList"
            :fields="fields"
            primary-key="id"
            :current-page="currentPage"
            :per-page="perPage"
            :busy="loading"
            thead-class="d-none"
            :filter="filterString"
            :filter-included-fields="filterIncludedFields"
            @filtered="onTableFiltered"
            hover
            class="bg-white shadow border"
            show-empty
        >
            <template #cell(name)="data">
                <b-button-group size="sm" class="mr-2">
                    <b-button 
                        v-b-tooltip.hover.top title="Edit"
                        variant="minimal-primary" 
                        @click="startUpdate(data.item)"
                    >
                        <b-icon icon="pencil"></b-icon>
                    </b-button>
                    <b-button 
                        v-b-tooltip.hover.top title="Delete"
                        variant="minimal-danger" 
                        @click="startDelete(data.item)"
                    >
                        <b-icon icon="trash"></b-icon>
                    </b-button>
                </b-button-group>
                <span class="" style="font-weight: 500;">{{ data.value }}</span>
            </template>
        </b-table>
        <base-table-pagination
            v-if="totalRows" 
            :current-page.sync="currentPage"
            :per-page.sync="perPage"
            :total-items="totalRows"
            :item-name="itemNamePlural"
        ></base-table-pagination>

        <b-modal
            v-model="showEditModal"
            :title="itemNameSingularCapitalized"
            centered
            @hidden="onModalHidden"
            @ok="handleOk"
        >
            <!-- <p v-if="formError" class="text-danger">{{ formErrorMsg }}</p> -->
            <busy-spinner v-if="saving" inner-class="py-3" text="Saving..."></busy-spinner>
            <hot-edit-input
                v-else 
                :label="itemNameSingularCapitalized + ' Name'"
                v-model="activeItem.name"
                edit-mode
                autofocus
                @keyup-enter="handleOk"
            ></hot-edit-input>
        </b-modal>
    </div>
</template>

<script>
// USED FOR MANAGING SIMPLE LIST OF TAGS / CATEGORIES - should have ONE FIELD called 'name'
import { suppliosApi } from '../js/api-service';
import { errorHandling } from '../js/custom-vue-mixins';
import { HotEditInput } from '../js/custom-form-components';
import merge from 'lodash/merge';
import cloneDeep from 'lodash/cloneDeep';
import capitalize from 'lodash/capitalize';
import BaseTablePagination from './BaseTablePagination';
//import BaseSearchBox from './BaseSearchBox';
//import { errorMessageMaker } from '../js/filters-helpers';

export default {
    name: 'BaseTaxonomyCrud',
    components: {
        HotEditInput,
        BaseTablePagination,
        //BaseSearchBox,
    },
    mixins: [
        errorHandling,
    ],
    props: {
        endpointName: {  // API endpoint name used in suppliosApi._______.list() - used for list, create, partialUpdate, destroy
            type: String,
            required: true,
        },
        itemTitle: { // plural full/long name of item - like 'Sourcing Tags' - should be plural
            type: String,
            required: true,
        },
        itemNameSingular: { // short singular name like 'tag', 'category'
            type: String,
            required: true,
        },
        itemNamePlural: {  // short plural name like 'tags', 'categories'
            type: String,
            required: true,
        }
    },
    data: function() {
        return {
            /* errorMsg: 'Error',
            error: false,
            formErrorMsg: 'Error',
            formError: false, */
            loading: false,
            saving: false,
            showEditModal: false,  // v-model for show/hide modal
            itemList: [],  // put item list here after fetching from API
            fields: ['name'],  // cols to show in b-table
            totalRows: null,  // set to itemList.length on getList, and onTableFiltered to filtered length
            activeItem: {},
            blankItem: {
                name: '',
            },
            filterString: '', // feed this into b-table filter prop, v-model from filter input box
            filterIncludedFields: ['name'],  // filter is applied to these cols in b-table
            currentPage: 1,
            perPage: 25,
        }
    },
    computed: {
        itemNameSingularCapitalized: function() {
            return capitalize(this.itemNameSingular);
        },

    },
    created: function() {
        this.resetActiveItem();
    },
    mounted: function() {
        this.getList();
    },
    methods: {
        /* handleError: function(error, message) {
            console.log(message);
            console.log(error);
            this.errorMsg = errorMessageMaker(message);
            this.error = true;
        },
        handleFormError: function(error, message) {
            console.log(message);
            console.log(error);
            this.formErrorMsg = errorMessageMaker(message);
            this.formError = true;
        }, */
        resetActiveItem: function() {
            this.activeItem = merge({}, this.blankItem);
        },
        onModalHidden: function() {
            this.resetActiveItem();
            //this.formError = false;
        },
        resetFilter: function() {
            this.filterString = '';
        },
        onTableFiltered: function(filteredItems) {
            // gets called anytime filtered results change
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },
        getList: function() {
            this.loading = true;
            this.resetFilter();
            let axiosParams = {
                params: {
                    // put ordering or filter params in here, if any
                },
            };
            suppliosApi[this.endpointName].list(axiosParams)
            .then(response => {
                console.log('Got list from API, response below');
                console.log(response);
                this.itemList = response.data;
                this.totalRows = this.itemList.length;
            })
            //.catch(error => this.handleError(error, 'Error while getting list'))
            .catch(error => this.apiErrorHandler(error, 'Error while getting list'))
            .finally(() => this.loading = false)
        },
        startCreate: function() {
            this.showEditModal = true;
        },
        startUpdate: function(itemObj) {
            this.activeItem = merge({}, this.activeItem, itemObj);
            this.showEditModal = true;
        },
        handleOk: function(bvModalEvt) {
            // handle click on modal OK, then delegate to Create or Update method
            bvModalEvt.preventDefault();  // prevent modal from closing
            let saveData = cloneDeep(this.activeItem);
            if (saveData && 'id' in saveData && saveData.id) {
                // if we have ID in the activeItem, it is an UPDATE
                this.performUpdate(saveData);
            } else {  // otherwise it is a CREATE new item
                this.performCreate(saveData);
            }
        },
        performCreate: function(saveData) {
            this.saving = true;
            suppliosApi[this.endpointName].create(saveData)
            .then(response => {
                console.log('Posted new item - response below:');
                console.log(response);
                this.showEditModal = false;
                this.showSuccessToast(this.itemNameSingularCapitalized + ' successfully added');
                this.getList();
            })
            //.catch(error => this.handleFormError(error, error.response.data))
            .catch(error => this.apiErrorHandler(error, 'Error while adding this item'))
            .finally(() => {
                this.saving = false;
            })
        },
        performUpdate: function(saveData) {
            this.saving = true;
            suppliosApi[this.endpointName].partialUpdate(saveData.id, saveData)
            .then(response => {
                console.log('Updated item, response below');
                console.log(response);
                this.showEditModal = false;
                this.showSuccessToast(this.itemNameSingularCapitalized + ' successfully updated');
                this.getList();
            })
            //.catch(error => this.handleFormError(error, error.response.data))
            .catch(error => this.apiErrorHandler(error, 'Error while adding this item'))
            .finally(() => {
                this.saving = false;
            })
        },
        showSuccessToast: function(content) {
            this.$toast.success(content);
            /* this.$bvToast.toast(content ,{
                title: 'Success',
                solid: true,
            }); */
        },
        startDelete: function(itemObj) {
            this.$bvModal.msgBoxConfirm(`Are you sure you want to delete ${this.itemNameSingular}: ` + itemObj.name, {
                title: 'Please Confirm',
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'danger',
                okTitle: 'Yes, Delete',
                cancelTitle: 'No, Cancel',
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
            })
            .then(value => {
                // value resolves to true if OK is clicked, false if cancel clicked, or null if modal closed
                if (value === true) {
                    this.performDelete(itemObj);
                    console.log("From delete confirm modal, we just called performDelete");
                }
            })
            //.catch(error => this.handleError(error, 'Error while performing delete'))
            .catch(error => this.apiErrorHandler(error, 'Error while performing delete'))
        },
        performDelete: function(itemObj) {
            this.saving = true;
            suppliosApi[this.endpointName].destroy(itemObj.id)
            .then(response => {
                console.log('Deleted item, response below');
                console.log(response);
                this.showSuccessToast(this.itemNameSingularCapitalized + ' successfully deleted');
                this.getList()
            })
            //.catch(error => this.handleError(error, 'Error while removing the item'))
            .catch(error => this.apiErrorHandler(error, 'Error while removing the item'))
            .finally(() => this.saving = false)
        },
    }
}
</script>

<style>

</style>